<template>
  <v-dialog v-model='showDialog' :max-width='width' persistent :fullscreen='fullscreen' @keydown.esc='escapePressed'>
    <v-card :loading='cardLoading' :tile="fullscreen ? true : false">
      <v-toolbar dense dark flat :color='color' v-if='!hideToolbar'>
        <v-icon color='white' left>{{ icon }}</v-icon>
        <v-toolbar-title>
          {{ title }}
          <span class='grey--text text-uppercase subtitle-2 ml-2'>{{ subtitle }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot name='toolbarButtons'></slot>
      </v-toolbar>
      <v-divider class='mb-2'></v-divider>
      <slot name='dialog-form'></slot>
      <v-card-text class='pt-3'>
        <slot name='dialog-text'></slot>
        <span v-html="body_text"></span>
        <slot></slot>
      </v-card-text>
      <v-card-text v-if='showError'>
        <v-icon color='red'>mdi-alert</v-icon> There was an error!
      </v-card-text>
      <slot name='fullWidth'></slot>
      <v-card-actions>
        <slot name='dialog-actions'></slot>
        <v-spacer v-if='!hideButtons'></v-spacer>
        <wc-save-cancel-buttons v-if='!hideButtons' :hideCancel='hideCancel' :hideSave='hideSave'
          :disabled='disableButtons' :loading='loadingButtons' @cancel='cancel' @save='save' :cancelText='cancelText'
          :cancelColor='cancelColor' :saveText='saveText' :saveColor='saveColor' />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'wc-dialog',
  props: {
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    },
    showError: {
      required: false,
      type: Boolean,
      default: false
    },
    color: {
      required: false,
      default: 'primary'
    },
    width: {
      required: false,
      type: String,
      default: '600'
    },
    title: {
      required: false,
      type: String,
      default: 'No Title?'
    },
    subtitle: {
      required: false,
      type: String,
      default: ''
    },
    icon: {
      required: false
    },
    iconColor: {
      required: false,
      default: 'white'
    },
    loadingButtons: {
      required: false,
      default: false,
      type: Boolean
    },
    disableButtons: {
      required: false,
      default: false,
      type: Boolean
    },
    saveText: {
      required: false,
      default: 'Save',
      type: String
    },
    cancelText: {
      required: false,
      default: 'Cancel',
      type: String
    },
    cancelColor: {
      required: false,
      default: '',
      type: String
    },
    saveColor: {
      required: false,
      default: 'primary',
      type: String
    },
    hideCancel: {
      required: false,
      default: false,
      type: Boolean
    },
    hideSave: {
      required: false,
      default: false,
      type: Boolean
    },
    fullscreen: {
      required: false,
      default: false,
      type: Boolean
    },
    hideToolbar: {
      required: false,
      default: false,
      type: Boolean
    },
    hideButtons: {
      required: false,
      default: false,
      type: Boolean
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    },
    body_text: {
      required: false,
      default: '',
      type: String
    }
  },
  computed: {
    cardLoading() {
      if (this.loading || this.loadingButtons) {
        return 'info'
      }
      return false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('save')
    },
    escapePressed() {
      this.cancel()
    }
  }
}
</script>
